import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CartType {
  value: string;
  label: string;
}

interface CartSearchState {
  searchData: string;
  searchResults: any[];
  status: { value: string; label: string };
  cartType: CartType;
  cartsRowsPerPage: number;
}

const initialState: CartSearchState = {
  searchData: "",
  searchResults: [],
  status: { value: "ALL", label: "All" },
  cartType: { value: "all", label: "All" },
  cartsRowsPerPage: 10,
};

const cartSearchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearchData: (state, action: PayloadAction<string>) => {
      state.searchData = action.payload;
    },
    setSearchResults: (state, action: PayloadAction<any[]>) => {
      state.searchResults = action.payload;
    },
    setCartStatus: (state, action: PayloadAction<{ value: string; label: string }>) => {
      state.status = action.payload;
    },
    setCartType: (state, action: PayloadAction<CartType>) => {
      state.cartType = action.payload;
    },
    setCartsRowsPerPage: (state, action: PayloadAction<number>) => {
      state.cartsRowsPerPage = action.payload;
    },
    clearCartsRowsPerPage: (state) => {
      state.cartsRowsPerPage = 10;
    },
  },
});

export const {
  setSearchData,
  setSearchResults,
  setCartStatus,
  setCartType,
  setCartsRowsPerPage,
  clearCartsRowsPerPage,
} = cartSearchSlice.actions;
export default cartSearchSlice.reducer;